// i18n area 'system' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.lt-LT.meta.json.
import type { enUS } from './system'

export const ltLT: typeof enUS = {
  diagnostics: {
    title: 'Diagnostika',
    subtitle: 'Kas negerai, blogiausia pirmiausia — tas pats objektyvas kaip tvirt diagnose',
    reload: 'Įkelti iš naujo',
    loadError: 'Diagnozės nepavyko perskaityti',
    exportBundle: 'Eksportuoti paketą',
    exportError: 'Paketo nepavyko sukurti',
    noProblem: 'Patikrintose srityse problemų nėra',
    nothingInspected: 'NIEKAS nebuvo patikrinta — tai nėra sveikatos pažyma',
    inspected: 'Patikrintos',
    notInspected: 'NEPATIKRINTOS',
    localHint: 'Mazgo lokalios sritys (systemd vienetai, žurnalas) skaitomos tik iš CLI: tvirt diagnose --area local — kelias, kai API neatsako.',
    thresholds: 'nepavykusios užduotys per {hours} val., heartbeat vėluoja daugiau nei {seconds} s',
    severity: {
      critical: 'Kritinis',
      warning: 'Įspėjimas',
      unknown: 'Nežinoma'
    }
  },
  explorer: {
    title: 'Naršyti išteklius',
    root: 'Šaknis',
    empty: 'Šiame scope išteklių nėra',
    previewHint: 'Pasirinkite objektą, kad pamatytumėte jo peržiūrą',
    open: 'Atverti',

    // CRUD sąrašų giliosios nuorodos ?scope= (round #109), iš naršyklės (#143).
    openScoped: 'Atverti sąrašą šiame scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM template',
      ct: 'CT',
      ctTemplate: 'CT template',
      app: 'App',
      overlayNetwork: 'Overlay tinklas',
      networkService: 'Tinklo paslauga',
      fabric: 'Fabric',
      subnet: 'Potinklis',
      storage: 'Storage telkinys',
      disk: 'Diskas',
      catalogFile: 'Katalogo failas',
      ociRegistry: 'OCI registry',
      ociImage: 'OCI atvaizdis',
      cephCluster: 'Ceph klasteris',
      backupDestination: 'Atsarginių kopijų paskirties vieta',
      user: 'Naudotojas',
      group: 'Grupė',
      role: 'Rolė',
      credential: 'Prisijungimo duomenys',
      tag: 'Žyma',
      proximityRule: 'Proximity taisyklė'
    }
  },
  tags: {
    title: 'Žymos',
    empty: 'Žymų nėra',
    add: 'Pridėti žymą',
    remove: 'Pašalinti',
    name: 'Žyma',
    value: 'Reikšmė',
    save: 'Įrašyti',
    saveError: 'Nepavyko įrašyti žymų',
    loadError: 'Nepavyko įkelti žymų žodyno',
    noVocabulary: 'Šiam išteklių tipui nėra galimų žymų',

    // Jau priskirta vienos reikšmės žyma atsako 409: pakeitimas visada yra
    // aiškus — niekada nenumanomas (dizainas, ratifikuota 2026-07-27).
    overwrite: 'Pakeisti dabartinę reikšmę',

    // Sistema > Žymos: žodyno paviršius.
    createTitle: 'Kurti žymą',
    editTitle: 'Redaguoti žymą',
    nameHint: 'Raidės, skaitmenys, taškai, brūkšneliai ir pabraukimai — jokių „:“ ar „/“; priešdėlis tvirt- rezervuotas platformai',
    cardinality: 'Kardinalumas',
    cardinalitySingle: 'Viena reikšmė',
    cardinalityMultiple: 'Kelios reikšmės',
    cardinalityHint: 'Kai reikšmė viena, priskiriant žymą iš naujo prašoma ją pakeisti',
    autoCreate: 'Automatinis reikšmių kūrimas',
    autoCreateOn: 'Priskiriant',
    autoCreateOff: 'Tik deklaruotos',
    autoCreateHint: 'Įjungta: priskyrus naują reikšmę ji sukuriama. Išjungta: priskiriamos tik deklaruotos reikšmės',
    values: 'Reikšmės',
    noValues: 'Nedeklaruota nė viena reikšmė',
    addValue: 'Pridėti reikšmę',
    duplicateValue: 'Reikšmė kartojasi',
    kinds: 'Išteklių tipai',
    kindsAll: 'Visi',
    kindsPlaceholder: 'Visi',
    kindsHint: 'Palikite tuščią, kad būtų leidžiamas kiekvienas žymimas išteklių tipas',
    systemChip: 'Sistema',
    deleteCascade: 'Pašalinti ir priskyrimus',
    deleteCascadeHint: 'Žyma, vis dar priskirta kuriam nors ištekliui, atmetama: su šia parinktimi reikšmės ir visi priskyrimai pašalinami kartu su žyma.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Kurti scope',
    editTitle: 'Pervadinti scope',
    path: 'Kelias',
    segment: 'Segmentas',
    segmentHint: 'Mažosios raidės, skaitmenys ir brūkšneliai (DNS-1123)',
    parent: 'Tėvinis',
    rootChip: 'Šaknis',
    preview: 'Naujas scope',
    pickLabel: 'Scope',
    pickHint: 'Kur objektas gyvena klasterio medyje — šaknyje ar jos viduje esančiame vDC.',
    ociCache: 'OCI podėlis (override)',
    appEphemeral: 'App efemeriniai telkiniai (override)',
    inherit: 'Paveldėti',
    inheritsFrom: 'Paveldi iš',
    inheritsCluster: 'Paveldi klasterio numatytąjį',
    inheritsNone: 'Paveldi — efektyvaus telkinio nėra',
    failoverProtection: 'Apsauga degradavusiame klasteryje',
    networkWeight: 'Tinklo svoris',
    networkCeil: 'Tinklo lubos (Mbps)',
    protectionProtected: 'Apsaugota',
    protectionExpendable: 'Paaukojama degradavus',
    protectionDefault: 'Klasterio numatytoji'
  },

  // Sistema > Informacija (round #124, 2026-07-31): platformos versijos parke
  // (daugiausia dvi atnaujinimo metu), kiekvieno mazgo komponentai, vietoje
  // teikiamas PDF vadovas ir įterpta licencijos kortelė.
  sysinfo: {
    summary: 'Platformos versijos klasteryje, kiekvieno mazgo komponentai, administravimo vadovas ir licencija.',
    platformTitle: 'TVirt platforma',
    platformSubtitle: 'Klasterio mazguose stebimos versijos',
    versionOnNodes: '{version} — mazgų: {n}',
    versionOnOneNode: '{version} viename mazge',
    mixedVersions: 'Klasteryje yra daugiau nei viena platformos versija — tikėtina tik vykstant atnaujinimui (daugiausia dvi).',
    tooManyVersions: 'Klasteryje yra daugiau nei dvi platformos versijos — taip nebūna niekada, net ir atnaujinimo metu: patikrinkite žemiau esančius mazgus.',
    unreportedNodes: 'Versijų dar nepranešė: {nodes}',
    noVersionsYet: 'Nė vienas mazgas dar nepranešė savo versijų.',
    nodesUnavailable: 'Su jūsų teisėmis mazgų sąrašas nematomas — parodyti platformos versijų neįmanoma.',
    colNode: 'Mazgas',
    manualTitle: 'Administravimo vadovas',
    manualSubtitle: 'Vietinė kopija, teikiama šio klasterio',
    manualBody: 'Visas TVirt vadovas PDF formatu, teikiamas tiesiai iš platformos — prieinamas ir izoliuotose (air-gapped) aplinkose.',
    manualLink: 'Administravimo vadovas (PDF)',
    apiExplorerTitle: 'API naršyklė',
    apiExplorerSubtitle: 'OpenAPI kontraktas, naršomas',
    apiExplorerBody: 'Visas platformos OpenAPI kontraktas — kiekvienas maršrutas, schema ir atsakymo kodas — naršomas iš naršyklės, pateikiamas per šį mazgą.',
    apiExplorerLink: 'Naršyti API',
    kubeTitle: 'Suderinamumas su Kubernetes',
    kubeSubtitle: 'kubectl ir jo įrankiai priešais natyvųjį API',
    kubeBody: 'TVirt KubeCompat projektuoja Pod, Deployment, Service objektus, vardų sritis, mazgus ir įvykius į Kubernetes dialektą — tik skaitymui, plius Deployment šalinimas. Kiekvienas kvietimas eina per natyvųjį API su tavo teisėmis: kubeconfig faile naudok app token kaip bearer.',
    kubeEndpoint: 'Endpoint kubectl',
    kubeStatusActive: 'Aktyvus — Kubernetes {version}',
    kubeStatusMissing: 'Neįdiegta šiame mazge (paketas trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Įdiegta, bet neatsako — patikrink vienetą trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Tikrinama…'
  },

  // Licencijavimas (round 2026-07-29): prenumeratos licencijos puslapis.
  licensing: {
    title: 'Klasterio licencija',
    subtitle: 'Prenumeratos licencija — daugiausia viena klasteriui',
    absentTitle: 'Neužregistruota jokia licencija',
    absentBody:
      'Be galiojančios licencijos klasteris atsisako paleisti naujas virtualiąsias mašinas (veikiančios VM lieka veikti). Užregistruokite su prenumerata gautą produkto raktą.',
    registerButton: 'Registruoti licenciją',
    removeButton: 'Pašalinti licenciją',
    state: {
      ok: 'Galioja',
      limitExceeded: 'Viršyta riba',
      expired: 'Nebegalioja'
    },
    productKeyLabel: 'Produkto raktas',
    basisLabel: 'Ribos pagrindas',
    basis: {
      concurrentVms: 'Kartu veikiančios VM',
      physicalCores: 'Fiziniai branduoliai (viso klasterio)'
    },
    limitLabel: 'Riba',
    usageLabel: 'Dabartinis naudojimas',
    usageOf: '{used} iš {limit}',
    usagePartial: 'dalinė suma — mazgų be stebimos CPU topologijos: {n}',
    usageUnknown: 'šiuo metu nestebima',
    expiresLabel: 'Galioja iki',
    neverExpires: 'niekada',
    registeredLabel: 'Užregistruota',
    gateNote:
      'Kai licencijos nėra, ji nebegalioja arba viršyta jos riba, klasteris atsisako paleisti NAUJAS virtualiąsias mašinas. Veikiančios VM lieka veikti, o HA paleidimams iš naujo tai neturi įtakos.',
    devStage:
      'Kūrimo etapas: produkto raktas priimamas toks, koks yra, kartu su čia deklaruotomis ribomis; patikra pasirašytu raktu atsiras būsimoje laidoje.',
    dialogTitle: 'Registruoti licenciją',
    dialogExpiresHelp: 'Tuščia = licencijos galiojimas niekada nesibaigia',
    dialogSubmit: 'Registruoti',
    dialogError: 'Nepavyko užregistruoti licencijos.',
    removeTitle: 'Pašalinti licenciją',
    removeBody:
      'Klasteris liks BE LICENCIJOS: naujos virtualiosios mašinos atsisakys pasileisti, kol neužregistruosite kitos. Veikiančios VM lieka veikti.',
    removeConfirm: 'Pašalinti',
    removeError: 'Nepavyko pašalinti licencijos.'
  },
  rbac: {
    tabRoles: 'Rolės',
    tabGrants: 'Teisių suteikimai',
    rolesTitle: 'Rolės',
    createRoleTitle: 'Kurti rolę',
    editRoleTitle: 'Redaguoti rolę',
    nameHint: 'Mažosios raidės, skaitmenys ir brūkšneliai; priešdėlis tvirt- rezervuotas',
    systemChip: 'Sistema',
    permissions: 'Teisės',
    permissionsPlaceholder: 'Pridėti teisę…',
    includedRoles: 'Įtrauktos rolės',
    includedRolesPlaceholder: 'Pridėti rolę…',
    grantsTitle: 'Teisių suteikimai',
    createGrantTitle: 'Kurti teisių suteikimą',
    principal: 'Principal',
    principalKind: 'Principal tipas',
    principalUser: 'Naudotojas',
    principalGroup: 'Grupė',
    role: 'Rolė',
    grantRight: 'Delegavimas',
    grantRightChip: 'Gali deleguoti',
    grantRightLabel: 'Su teise deleguoti (gavėjas gali šią rolę deleguoti toliau)',
    effective: 'Galiojantis',
    notEffective: 'Negaliojantis',
    createdAt: 'Sukurta',
    scopeHint: '/kelias tikslus, /kelias/* rekursyvus — teisių suteikimai kabinami prie prijungtos šaknies (/* suteikti negalima)'
  },
  groups: {
    title: 'Grupės',
    createTitle: 'Kurti grupę',
    nameHint: 'Mažosios raidės, skaitmenys ir brūkšneliai; unikalus scope viduje',
    members: 'Nariai',
    membersTitle: 'Nariai',
    membersPlaceholder: 'Pridėti naudotoją…',
    noMembers: 'Narių nėra',
    realmMappings: 'Realm atitikmenys',
    realmMappingsTitle: 'Realm atitikmenys',
    realmMappingsHint:
      'Ką ši grupė atitinka kiekviename išoriniame realm. Narystė nuskaitoma iš katalogo prisijungimo metu: katalogo grupė, kurios čia niekas neatitinka, ignoruojama, o įdėtos grupės neišsprendžiamos — jas reikia suplokštinti katalogo pusėje.',
    realm: 'Realm',
    externalGroup: 'Išorinė grupė',
    addRealmMapping: 'Pridėti atitikmenį',
    removeRealmMapping: 'Pašalinti atitikmenį',
    noRealmMappings: 'Realm atitikmenų nėra',

    // Skiltimis suskirstytas kūrimo dialogas (round realm-wizard, 2026-08-03):
    // Bendra plius atitikmenų su išoriniais realm paviršius su kalbančia tuščia
    // būsena.
    sectionGeneral: 'Bendra',
    mappingsNoRealms: 'Nesukonfigūruotas nė vienas išorinis realm — atitikmenų paviršius atsirakina, vos tik atsiranda realm.',
    mappingsNoRealmsLink: 'Atverti kortelę Realm ir SSO',

    // Grupės uždedamas MFA privalomumas (raundas #178, pusė B): grynas OR —
    // grupė privalomumą gali tik PRIDĖTI, niekada jo nenuimti.
    mfaRequired: 'MFA privalomumas',
    mfaRequiredChip: 'Įpareigoja MFA',
    mfaNotRequiredChip: 'Privalomumo nėra',
    mfaRequiredHint:
      'Grynas OR: grupė gali PRIDĖTI antro veiksnio privalomumą savo nariams — taip pat išorinėms tapatybėms per realm atitikmenis — bet niekada jo nenuimti. Galioja nuo kito prisijungimo: atviri seansai neuždaromi.'
  },
  users: {
    title: 'Naudotojai',
    createTitle: 'Kurti naudotoją',
    editTitle: 'Redaguoti naudotoją',
    username: 'Naudotojo vardas',
    usernameHint: 'Mažosios raidės, skaitmenys, taškai ir brūkšneliai',
    displayName: 'Rodomas vardas',
    enabled: 'Įjungtas',
    state: 'Būsena',
    enabledChip: 'Įjungtas',
    disabledChip: 'Išjungtas',
    lockedChip: 'Užrakintas',
    password: 'Slaptažodis',
    passwordSetChip: 'Nustatytas',
    mustChangeChip: 'Keistinas',
    initialPassword: 'Pradinis slaptažodis',
    initialPasswordHint: 'Naudotojas turės jį pakeisti pirmą kartą prisijungęs',
    lastLogin: 'Paskutinis prisijungimas',
    neverLoggedIn: 'Niekada neprisijungė',
    setPasswordTitle: 'Nustatyti slaptažodį',
    setPasswordHint: 'Administracinis pakeitimas — reikalauja jūsų slaptažodžio (sudo režimas) ir įpareigoja naudotoją jį pakeisti kitą kartą prisijungiant.',
    operatorPassword: 'Jūsų slaptažodis',
    unlock: 'Atrakinti paskyrą',
    revokeTitle: 'Panaikinti seansus',
    revokeBody: 'Visi aktyvūs šio naudotojo seansai nedelsiant nutraukiami.',
    revokeIncludeTokens: 'Panaikinti ir app token',
    revokeConfirm: 'Panaikinti',

    // Standartinis dialogas (round #156): išsamios detalės, paskyros ir saugumo kortelės.
    tabAccount: 'Paskyra',
    tabSecurity: 'Saugumas',
    usernameImmutableHint: 'Naudotojo vardas yra paskyros tapatybė — nustatomas kuriant',
    groups: 'Grupės',
    noGroups: 'Grupių nėra',
    mustChangePassword: 'Privalomas slaptažodžio keitimas',
    failedAttempts: 'Nepavykę prisijungimo bandymai',
    lockedUntil: 'Užrakinta iki',

    // Tapatybės kortelės (2026-08-03): Sistema > Naudotojai tapo kortelėmis
    // suskirstyta skiltimi pagal /system/rbac pavyzdį — naudotojai, grupės,
    // išoriniai realm.
    tabUsers: 'Naudotojai',
    tabGroups: 'Grupės',
    tabRealms: 'Realm ir SSO',
    tabMfa: 'MFA',

    // MFA kortelė (task #178, A pusė — GUI ant esamo contract): antro veiksnio
    // vaizdas kiekvienam naudotojui. Išorinių tapatybių enrollment ir našlaičio
    // būsena yra B pusė — contract raundas, niekada forma be backend.
    mfa: {
      title: 'Antras veiksnys (MFA)',
      methodsTitle: 'Galimi metodai',
      methodsSubtitle: 'Ką šis diegimas moka patikrinti kaip antrą veiksnį',
      methodsError: 'Nepavyko įkelti metodų registro',
      builtinChip: 'Integruotas',
      enrollableChip: 'Enrollment TVirt sistemoje',
      delegatedChip: 'Tvarkomas išorėje',
      state: 'Būsena',
      stateActive: 'Aktyvus',
      statePending: 'Laukiama enrollment',
      stateNone: 'Be enrollment',
      required: 'MFA privalomumas',
      requiredChip: 'Privalomas',
      notRequiredChip: 'Neprivalomas',
      enrolledAt: 'Enrollment data',
      enrolledMethods: 'Metodai su enrollment',
      noMethods: 'Enrollment nėra',
      codesRemaining: 'Likę atkūrimo kodai',
      resetTitle: 'Nustatyti antrą veiksnį iš naujo',
      resetHint:
        'Enrollment ir visi atkūrimo kodai išvalomi: kitą kartą prisijungdamas naudotojas enrollment atliks nuo pradžių. MFA privalomumas lieka toks, koks buvo — administratorius niekada nenustato paslapties, jis ją tik išvalo.',
      resetConfirm: 'Nustatyti iš naujo',
      resetError: 'Nepavyko iš naujo nustatyti antro veiksnio',
      empty: 'Kol kas nėra nė vieno valdomo naudotojo — paskyros čia pasirodo, vos tik sukuriamos, kiekviena su savo antro veiksnio būsena.',

      // Pusė B (raundas #178): galiojančio verdikto kilmė, išoriniai
      // enrollment su našlaičio būsena, grupės, kurios įpareigoja.
      viaSelf: 'Asmeninis',
      viaSelfHint: 'Asmeninis paskyros indėlis (jos vėliavėlė) — vienintelė dalis, kurią keičia pieštukas.',
      viaGroupHint: 'Iš šios grupės paveldėtas privalomumas: nuėmus asmeninę vėliavėlę naudotojas neišlaisvinamas — veikiama grupėje, kortelėje Grupės.',
      subject: 'Tapatybė',
      lastSeenAt: 'Paskutinis patvirtinimas',
      enrollmentPending: 'Laukiama',
      orphanChip: 'Našlaitis',
      orphanDirectoryMiss: 'Tapatybės kataloge nebėra',
      orphanRealmRemoved: 'Realm pašalintas iš TVirt',
      orphanedAt: 'Našlaitis nuo',
      directoryUuid: 'UUID kataloge',
      externalTitle: 'Išoriniai enrollment',
      externalEmpty: 'Kol kas nėra nė vieno išorinio enrollment — jis atsiranda per pirmą katalogo tapatybės su MFA privalomumu prisijungimą.',
      orphanHelp:
        'Našlaičiu tapęs enrollment niekada neišsitrina pats: tai saugumo medžiaga — jis lieka auditui, o jei tapatybė vėl pasirodo kataloge, ji atgauna savo veiksnį. Vienintelė išeitis — administracinis nustatymas iš naujo.',
      visibilityHint: 'Išoriniai enrollment gyvena klasterio šaknyje: juos mato tik tas, kas turi user.read visam medžiui.',
      orphanResetHint:
        'Našlaitė eilutė pašalinama visam laikui: niekas jos nebereikalauja. Jei tapatybė sugrįš į katalogą, enrollment ji atliks nuo pradžių.',
      enforcingTitle: 'Grupės, kurios įpareigoja MFA',
      enforcingSubtitle:
        'Privalomumo inkaras išorinėms tapatybėms yra grupė: jos realm atitikmenys pasako, kurią katalogo populiaciją jis pasiekia. Išorinis enrollment atsiranda per pirmą įpareigoto naudotojo prisijungimą.',
      enforcingEmpty: 'Nė viena grupė neįpareigoja MFA — privalomumas įjungiamas grupėje, kortelėje Grupės.',
      enforcingError: 'Nepavyko įkelti grupių, kurios įpareigoja MFA'
    }
  },
  realms: {
    title: 'Tapatumo nustatymo realm',
    createTitle: 'Kurti realm',
    editTitle: 'Redaguoti realm',
    name: 'Realm',
    nameHint: 'Domenas, kurį naudotojai rašo po @ (example.com) — po sukūrimo nekeičiamas',
    nameImmutableHint: 'Realm pavadinimas įrašytas kiekviename seanse ir kiekvienoje audito eilutėje, kuri jį kada nors minėjo — pervadinus būtų perrašyta istorija',
    kind: 'Tipas',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC ir SAML ateis su artimiausiais raundais — šiandien realm yra LDAPv3 katalogas',

    // Pusiau vediklis kuriant (round realm-wizard, 2026-08-03): 1 žingsnio tipų
    // kortelės — ldap gyvas, oidc/saml kortelės planuose (niekada forma be
    // backend už jos).
    kindCategory: 'Realm tipas',
    kindSelectHint: 'Pasirinkite katalogo tipą, kuriame šis realm tikrins tapatumą.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Naudotojo vardas ir slaptažodis tikrinami bind užklausa LDAPv3 kataloge — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Naršyklės single sign-on, deleguotas OpenID Connect tapatybės tiekėjui — ateis su artimiausiais raundais.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Įmonės single sign-on su SAML 2.0 tvirtinimais — ateis su artimiausiais raundais.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Įjungtas',
    urls: 'Katalogo serveriai',
    urlsHint: 'Po vieną ldap:// arba ldaps:// URL eilutėje (1–8), bandomi iš eilės — failover, niekada ne balansavimas',
    startTls: 'StartTLS',
    verifyCertificate: 'Tikrinti sertifikatą',
    cleartextWarning: 'Be ldaps:// arba StartTLS bind slaptažodis keliauja tinklu atviru tekstu — priimtina laboratorijoje, niekada gamyboje.',
    noVerifyWarning: 'Nepatikrinta TLS sesija neautentifikuoja nieko: tikrinimą išjunkite tik jungdamiesi prie katalogo, kurio negalite sutvarkyti.',
    caCertificate: 'CA sertifikatas (PEM)',
    caCertificateHint: 'Neprivalomas CA rinkinys, prisegtas šio realm TLS/StartTLS rankos paspaudimui; tuščia jį pašalina',
    caCertificatePinned: 'Prisegtas',
    connectTimeout: 'Skirtasis laikas (sekundėmis)',
    connectTimeoutHint: 'Kiekvieno URL prisijungimo ir užklausos terminas (1–60); jam pasibaigus bandomas kitas URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Paslaugos paskyra, atliekanti naudotojo paiešką; tuščia = anoniminis search bind (AD jį atmeta)',
    anonymousBind: 'Anoniminis search bind',
    bindCredential: 'Bind slaptažodis (keystore)',
    bindCredentialHint: 'Keystore usernamePassword įrašas su bind slaptažodžiu — paslaptis niekada negyvena pačiame realm',
    bindCredentialNone: 'Nėra (anoniminis bind)',
    bindCredentialEmpty: 'Keystore nėra nė vieno usernamePassword įrašo — bind slaptažodžiui sukurkite jį Sistema > Prisijungimo duomenys.',
    baseDn: 'Base DN',
    baseDnHint: 'Pomedis, nuo kurio prasideda naudotojo paieška (DC=example,DC=com)',
    userFilter: 'Naudotojo filtras',
    userFilterHint: '%u pakeičiama vietine prisijungimo vardo dalimi su RFC 4515 kaitos ženklais; ne AD katalogai paprastai nori (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf atributas',
    memberOfAttributeHint: 'Nuskaitomas tik kartą, prisijungiant — neatitiktos grupės ignoruojamos, įdėtos grupės neišsprendžiamos',
    uuidAttribute: 'UUID atributas',
    uuidAttributeHint: 'Realm viduje nekintantis UUID (objectGUID AD sistemoje, entryUUID OpenLDAP) — audite spausdinamas šalia naudotojas@realm',
    displayNameAttribute: 'Rodomo vardo atributas',
    displayNameAttributeHint: 'Naudojamas naudotojui pasveikinti; jo nesant naudojamas prisijungimo vardas',
    sudoHint: 'Realm rašymo veiksmai apsaugoti sudo: realm yra įėjimo į platformą durys',
    deleteBody: 'Realm grupių atitikmenys išeina kartu su juo; jo autentikuoti seansai lieka gyvi iki galiojimo pabaigos — ištrintas realm tiesiog nebeįleidžia nieko.',
    tabConnection: 'Ryšys',
    tabDirectory: 'Katalogas',
    testTitle: 'Tikrinti ryšį',
    testHint: 'Konfigūracijos zondas, niekada ne autentifikacija: prisijungia, atlieka bind su paslaugos paskyra ir — jei nurodytas naudotojo vardas — įvykdo naudotojo filtrą.',
    testUsername: 'Naudotojo vardas (nebūtinas)',
    testUsernameHint: 'Vietinė dalis, su kuria vykdomas naudotojo filtras — 1 atitiktis yra sveikas atsakymas',
    testRun: 'Vykdyti patikrą',
    testError: 'Nepavyko įvykdyti zondo',
    testReachable: 'Katalogas pasiekiamas, paslaugos bind priimtas',
    testUnreachable: 'Katalogas NEPASIEKIAMAS',
    matchedOne: 'Naudotojo filtras rado lygiai 1 įrašą — sveikas atsakymas.',
    matchedNone: 'Naudotojo filtras nerado nė vieno įrašo: neteisingas filtras arba base DN.',
    matchedMany: 'Naudotojo filtras rado įrašų: {count}. Jis nėra selektyvus, o prisijungimai būtų dviprasmiški (atmetami).',
    mappingsPointer: 'Ką atitinka išorinė grupė, yra TVirt grupės savybė (jos realm atitikmenys): tiesos taškas gyvena kortelėje Grupės.',
    mappingsPointerLink: 'Atverti kortelę Grupės',
    rootHomeHint: 'Išorinio realm tapatybės gyvena klasterio šaknyje, niekada vDC viduje: teisės suteikiamos ten, kur reikia, per teisių suteikimus — grupei arba tiesiai naudotojui, lygiai kaip ir vietinėms.'
  },
  credentials: {
    title: 'Prisijungimo duomenys',
    createTitle: 'Kurti prisijungimo duomenis',
    editTitle: 'Redaguoti prisijungimo duomenis',
    kind: 'Tipas',
    kindUsernamePassword: 'Naudotojo vardas ir slaptažodis',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph tapatybė)',
    kindHintUsernamePassword: 'Nekeičiamas. CIFS/SMB storage — prijungimo paskyra, kurios paslaptį worker naudoja prijungimo metu.',
    kindHintIscsiChap: 'Nekeičiamas. iSCSI CHAP tapatumo nustatymui — naudotojo vardas = CHAP vardas, paslaptis = CHAP paslaptis.',
    kindHintNvmeDhchap: 'Nekeičiamas. NVMe over Fabrics DH-HMAC-CHAP — paslaptis = DHHC-1:xx:… blobas; naudotojo vardas tėra etiketė.',
    kindHintCephx: 'Nekeičiamas. Ceph klientams — naudotojo vardas = kliento vardas (client.…), paslaptis = base64 raktas.',
    kindImmutableHint: 'Tipas po sukūrimo nekeičiamas — jį pakeisti reiškia naujus prisijungimo duomenis.',
    username: 'Naudotojo vardas',
    usernameChap: 'CHAP vardas',
    usernameNvme: 'Etiketė',
    usernameCephx: 'Kliento vardas',
    usernameHint: 'Neprivaloma paskyra, kuriai priklauso paslaptis',
    usernameHintChap: 'CHAP vardas, kuriuo autentifikuojasi initiator',
    usernameHintNvme: 'Transporto nenaudojama — laisva etiketė jūsų užrašams',
    usernameHintCephx: 'cephx kliento vardas — priešdėlis client. toleruojamas',
    secret: 'Paslaptis',
    secretHint: 'Tik rašymui: ją naudoja vartojantys komponentai, daugiau ji niekada nerodoma.',
    secretHintNvmeDhchap: 'Tik rašymui: DH-HMAC-CHAP host paslaptis kanonine forma DHHC-1:xx:… — ją naudoja vartojantys komponentai, daugiau ji niekada nerodoma.',
    secretHintCephx: 'Tik rašymui: base64 cephx raktas — jį naudoja vartojantys komponentai, daugiau jis niekada nerodomas.',
    secretEditHint: 'Palikite tuščią, kad paslaptis nesikeistų — užpildžius ji pakeičiama nauja.',
    createdAt: 'Sukurta',
    inUseError: '„{name}“ nurodyta storage konfigūracijoje — pirma ją ten atsiekite.',
    nameHint: 'Mažosios raidės, skaitmenys ir brūkšneliai (DNS-1123); unikalus kiekviename scope',

    // Vien rotacijai skirtas dialogas (round #156): paslaptis niekada neturi įterptinio pieštuko.
    rotateTitle: 'Pakeisti paslaptį',
    rotateHint: 'Tik rašymui: naujoji paslaptis pakeičia išsaugotąją — ją vartojantys komponentai naudos kito prijungimo metu.',

    // Round #159 (PKI): Sertifikatų ir CA kortelės.
    tabSecrets: 'Paslaptys',
    tabCertificates: 'Sertifikatai',
    tabAuthorities: 'Sertifikavimo institucijos',
    certificatesTitle: 'Sertifikatai',
    authoritiesTitle: 'Sertifikavimo institucijos',
    caCreateTitle: 'Nauja CA',
    certCreateTitle: 'Naujas sertifikatas',
    caMode: 'Kilmė',
    caModeGenerate: 'Generuoti su TVirt',
    caModeImport: 'Importuoti (raktas + sertifikatas)',
    certMode: 'Kilmė',
    certModeIssue: 'Išduoti iš keystore CA',
    certModeImport: 'Importuoti (raktas + sertifikatas)',
    issuingCa: 'Išduodančioji CA',
    issuingCaHint: 'Sertifikatas gimsta CA scope, su užregistruotu parent',
    noCasHint: 'Keystore nėra nė vienos CA — pirma ją sugeneruokite arba importuokite kortelėje CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'CA subject: raidės, skaitmenys, tarpas, taškas, pabraukimas, brūkšnys',
    commonNameCertHint: 'OpenVPN atpažįsta klientus pagal CN — laikykite jį unikalų kiekvienoje CA',
    days: 'Galiojimas (dienomis)',
    daysCaHint: '1–7300 dienų; numatytoji reikšmė 3650 (10 metų)',
    daysCertHint: '1–3650 dienų; numatytoji reikšmė 365',
    keyType: 'Rakto tipas',
    keyTypeHint: 'EC P-256 yra numatytasis; RSA — pasenusiems vartojantiems komponentams',
    usage: 'Paskirtis',
    usageClient: 'Klientas (clientAuth)',
    usageServer: 'Serveris (serverAuth)',
    usageHint: 'Extended key usage, kuriam sertifikatas išduodamas',
    san: 'Alternatyvūs vardai (SAN)',
    sanHint: 'Atskirti kableliais; IP literalai tampa IP: įrašais, visa kita — DNS:',
    keyPem: 'Privatusis raktas (PEM)',
    keyPemHint: 'Tik rašymui: saugomas keystore, daugiau niekada nerodomas',
    certPem: 'Sertifikatas (PEM)',
    certPemHint: 'Viešasis sertifikatas, poruojamas su raktu',
    certPemCaHint: 'CA sertifikatas, poruojamas su raktu (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Išdavėjas',
    parentCa: 'Išduodančioji CA',
    parentCaImported: 'Importuotas — išduotas ne TVirt viduje',
    serial: 'Serijos numeris',
    fingerprint: 'Kontrolinis kodas (SHA-256)',
    validFrom: 'Galioja nuo',
    validUntil: 'Galioja iki',
    expiry: 'Galiojimo pabaiga',
    expired: 'Nebegalioja',
    expiresInDays: 'Baigia galioti po {days} d.',
    revoked: 'Panaikintas',
    revokedAtLabel: 'Panaikinta',
    revokeTitle: 'Panaikinti sertifikatą',
    revokeAction: 'Panaikinti',
    revokeWarning: 'Panaikinimas galutinis: serijos numeris patenka į išduodančiosios CA CRL, ir kiekvienas panaikintus sertifikatus atmetantis vartotojas (pirmiausia OpenVPN) šį atmes. Panaikinimo atšaukti neįmanoma.',
    exportPem: 'Eksportuoti PEM',
    exportChain: 'Eksportuoti grandinės rinkinį',
    exportCrl: 'Eksportuoti CRL',
    materialImmutableHint: 'X.509 medžiaga nekeičiama — išduokite arba importuokite iš naujo',
    caInUseError: '„{name}“ dar turi gyvų išduotų sertifikatų (arba ją nurodo koks nors storage) — pirma juos panaikinkite arba ištrinkite.'
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Išdėstymas, pasiekiamumas ir afiniškumas — kur sukasi klasterio VM ir ar jos turi būti įjungtos',
    loadError: 'Proximity skydeliui reikia klasterio store — parko būsena šiuo metu nepasiekiama',
    config: {
      title: 'Konfigūracija',
      subtitle: 'Klasterio lygmens išdėstymo politika',
      save: 'Įrašyti',
      saveError: 'Konfigūracija buvo atmesta',
      strategy: 'Parinkimo strategija',
      strategy_leastUsedResources: 'Mažiausiai naudojama išteklių',
      strategy_leastVms: 'Mažiausiai VM',
      strategy_random: 'Atsitiktinė',
      strategyLeastUsedResourcesHint: 'Iš tinkamų kandidatų — mazgas, turintis daugiausia likusios naudojamos RAM (stebimas bendras kiekis − host rezervas − veikiančios VM); lygiosios sprendžiamos pagal vCPU įsipareigojimą. Esant tiems patiems duomenims, deterministinė.',
      strategyLeastVmsHint: 'Iš tinkamų kandidatų — mazgas, turintis mažiausiai veikiančių VM; lygiosios sprendžiamos pagal pavadinimą. Esant tiems patiems duomenims, deterministinė.',
      strategyRandomHint: 'Tolygiai atsitiktinė tarp tinkamų kandidatų.',
      liveness: 'Mazgų gyvybingumo riba (sekundėmis)',
      livenessHint: 'Ilgiau už šią ribą tylintis narys laikomas nepasiekiamu: neįtraukiamas į išdėstymą ir — jei nėra priežiūros režime — HA sprendėjo laikomas mirusiu; šis jį aptveria ir jo HA VM paleidžia kitur.',
      decider: 'HA sprendėjas',
      deciderNone: 'dar neišrinktas'
    },
    nodesTitle: 'Mazgai',
    nodesSubtitle: 'Gyvybingumas ir empirinė talpa — naudojama RAM = bendra − bazinė − įsipareigota',
    nodeCol: 'Mazgas',
    stateCol: 'Būsena',
    ramCol: 'RAM (bendra − bazinė − įsipareigota)',
    usableCol: 'Naudojama',
    vmsCol: 'Krūvis',
    neverSeen: 'niekada nematytas',
    freshChip: 'pasiekiamas',
    staleChip: 'nepasiekiamas',
    attestedChip: 'patvirtinta, kad išjungtas',
    ramFormula: 'bendra − bazinė − įsipareigota',
    haTitle: 'Aukštas pasiekiamumas',
    haSubtitle: 'VM su HA vėliavėle yra „visada įjungtos“: TVirt jas paleidžia iš naujo po kiekvieno neprašyto sustojimo — tame pačiame mazge su atidėjimu, kitame mazge, kai jų mazgas miršta (tik bendrinamas storage).',
    haNone: 'Nė viena VM dar neturi HA vėliavėlės — įjunkite ją čia arba VM detalėse.',
    haVmCol: 'Virtualioji mašina',
    haStateCol: 'Būsena',
    haRestartsCol: 'HA paleidimai iš naujo',
    haLastEventCol: 'Paskutinis įvykis',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA keitimas buvo atmestas',
    rules: {
      title: 'Afiniškumo taisyklės',
      createTitle: 'Nauja Proximity taisyklė',
      editTitle: 'Redaguoti taisyklę',
      nameHint: 'Mažosios raidės, skaitmenys ir brūkšneliai (DNS etiketė)',
      vms: 'Virtualiosios mašinos',
      vmsHint: 'Bent dvi VM — taisyklė riboja, kur jos sukasi viena kitos atžvilgiu',
      type: 'Tipas',
      affinity: 'Afiniškumas (kartu)',
      antiAffinity: 'Antiafiniškumas (atskirai)',
      typeAffinityHint: 'VM turi suktis TAME PAČIAME mazge.',
      typeAntiAffinityHint: 'VM turi suktis SKIRTINGUOSE mazguose — klasikinė HA pora.',
      mode: 'Režimas',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Pažeidimai atmeta operaciją (paleidimą, migravimą, failover) su kalbančiu klaidos pranešimu.',
      modeSoftHint: 'Pageidavimas, niekada neblokuojantis: pažeidžiantis išdėstymas įvyksta su matomu įspėjimu.',
      satisfied: 'Išdėstymas',
      satisfiedYes: 'atitinka',
      satisfiedNo: 'pažeista',

      // Standartinis dialogas (round #156): pažeidimai turi savo eilutę, ne tooltip.
      violations: 'Pažeidimai',
      noViolations: 'Nėra'
    },
    events: {
      title: 'HA įvykiai',
      subtitle: 'Pasiekiamumo žurnalas — paleidimai iš naujo, aptvėrimai, failover ir sąžiningi praleidimai',
      none: 'Kol kas nieko.',
      when: 'Kada',
      kind: 'Įvykis',
      target: 'Objektas',
      detail: 'Detalės',
      kindRestarted: 'HA paleidimas iš naujo',
      kindGaveUp: 'pasiduota (crash loop)',
      kindNodeAttested: 'mazgas aptvertas',
      kindFailedOver: 'failover',
      kindNoCandidate: 'nėra kandidato',
      kindStorageLocalSkip: 'praleista (vietinis storage)',
      kindZombieFenced: 'zombis nutrauktas'
    }
  }
}
